<script setup lang="ts">
const emit = defineEmits<{ (e: "open-install"): void }>();
</script>

<template>
  <section class="story os1-shell">
    <div class="story__grid">
      <div class="story__col">
        <span class="os1-eyebrow">House rules</span>
        <h3 class="story__title">Quiet first. Warm next.</h3>
        <p>
          OS1 is built for the person on the other end of the line. The clothes are
          warm — vermilion, oxblood, coral, terracotta — and the app behind them is
          quiet. No tracking, no upload by default, no checkout that demands twelve
          fields.
        </p>
        <p>
          We make in small runs and we tell you the run size. Items leave Porto,
          Biella, Naples, Como, and Scotland. The OS1 desktop app is a separate
          product, free, and it pairs with this store using a local handshake.
        </p>
      </div>
      <div class="story__col story__col--meta">
        <div class="story__row">
          <span class="story__row-key">Materials</span>
          <span>European linen · Wool / cashmere · Italian merino · Silk twill · Saddle leather</span>
        </div>
        <div class="story__row">
          <span class="story__row-key">Made in</span>
          <span>Porto · Biella · Naples · Como · Scotland</span>
        </div>
        <div class="story__row">
          <span class="story__row-key">Companion</span>
          <span>
            OS1 Desktop is the local file intelligence app. Free.
            <button class="story__link" @click="emit('open-install')">Install →</button>
          </span>
        </div>
        <div class="story__row">
          <span class="story__row-key">Returns</span>
          <span>30 days. Unworn, with the OS1 card.</span>
        </div>
        <div class="story__row">
          <span class="story__row-key">Privacy</span>
          <span>No tracking pixels. No retargeting. The cart lives in your browser.</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.story {
  padding-block: clamp(3rem, 6vw, 5rem);
  border-top: 1px solid var(--os1-line);
}

.story__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(1.4rem, 4vw, 3rem);
}

.story__title {
  font-size: var(--os1-step-4);
  color: var(--os1-paper);
  margin: 0.6rem 0 1.2rem;
  max-width: 18ch;
}

.story__col p {
  color: var(--os1-ink-soft);
  margin-top: 0.7rem;
  max-width: 46ch;
  font-size: 0.95rem;
}

.story__col--meta {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  border-left: 1px solid var(--os1-line);
  padding-left: clamp(1rem, 3vw, 2rem);
}

.story__row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 1rem;
  font-size: 0.85rem;
  color: var(--os1-ink-soft);
  padding-block: 0.6rem;
  border-bottom: 1px solid var(--os1-line);
}

.story__row-key {
  font-size: 0.62rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--os1-ink-mute);
}

.story__link {
  color: var(--os1-rose);
  border-bottom: 1px solid currentColor;
  margin-left: 0.3rem;
}

@media (max-width: 820px) {
  .story__grid {
    grid-template-columns: 1fr;
  }
  .story__col--meta {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid var(--os1-line);
    padding-top: 1.2rem;
  }
}
</style>
